import {LOCAL_CONFIG} from "@/config/cflocal.com";
import {FALCONATIONME_CONFIG} from "@/config/falconation.me";
import {STARTUPFALCON_INFO_CONFIG} from "@/config/startupfalcon.info";
import {STARUPFALCON_COM_CONFIG} from "@/config/startupfalcon.com";

let configObject;
let hostName = window.location.hostname.replace('www.', '');
switch (hostName){
    case 'cflocal.com':
        configObject = LOCAL_CONFIG;
        break;
    case 'app.falconation.me':
        configObject = FALCONATIONME_CONFIG;
        break;
    case 'app.startupfalcon.com':
        configObject = STARUPFALCON_COM_CONFIG;
        break;
}

export function config(key) {
    return configObject[key];
}
